// extracted by mini-css-extract-plugin
module.exports = {"close":"malt-close-Close-close-8d7d70d9","closeIcon":"malt-close-Close-closeIcon-7939dfaa"};